<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1"></a><b>Love Potions Through the Ages</b></h1>
<p class="titlea">Harry E. Wedeck</p>
<p class="centerimg"><img alt="image" class="Title Page" src="images/PhilosophicalLibrarylogo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_titlepage.vue?1290fb82